(function(){
  'use strict';
  
  angular
    .module('iqxCore')
    .controller('OwnerFavouritesCtrl', OwnerFavouritesCtrl)
  
  function OwnerFavouritesCtrl(actionDialogSvc, $scope, consultantListSvc, favouritesSvc) {
    var favourites = this
    
    favourites.display = []
    favourites.path = [{id:"", name:"Home"}]
    favourites.searchView = false
    favourites.searchValue = ""
    favourites.latestSearch = ""
    favourites.search = search
    favourites.closeSearch = closeSearch
    favourites.open = open
    favourites.openBreadcrumb = openBreadcrumb
    favourites.up = up
    favourites.showAddFolder = showAddFolder
    favourites.hideAddFolder = hideAddFolder
    favourites.addFolder = addFolder
    favourites.remove = remove
    favourites.addFolderView = false
    favourites.addFolderName = ""
    favourites.consultantList = []
    favourites.selectedConsultant = ""
    favourites.consultantSelf = true // will always default to self when first loaded
    favourites.load = load
    favourites.consultantSelected = consultantSelected
    favourites.isLoading = false

    var consultantSelf = ""
  
    activate()
  
    ///////////
  
    function activate(){
      favourites.isLoading = true
      consultantListSvc.get().then(function(res){
        favourites.consultantList = res
        angular.forEach(res, function(value){
          if(value.isMe){favourites.selectedConsultant=value.id; consultantSelf=value.id; value.name = value.name+" (me)"}
        })

        load()
      })
    }

    function display(){
      hideAddFolder()
      favourites.display = favouritesSvc.explore(favourites.path[favourites.path.length-1].id, favourites.selectedConsultant)
      favourites.isLoading = false
    }
    
    function open(item){
      if(item.type==="Heading"){
        if(favourites.searchView){ // if we are in search view close the search
          favourites.path = favouritesSvc.getPath(item, favourites.selectedConsultant)
          favourites.path.push({id:item.id, name:item.name})
          closeSearch() // close search calls display so no need to call it here
        }else{
          favourites.path.push({id:item.id, name:item.name})
          display()
        }
      }else{
        actionDialogSvc.show($scope, {
          linkID:item.objectID,
          type:item.type
        })
      }
    }

    function openBreadcrumb(key){
      favourites.path.length = key+1
      display()
    }

    function up(){
      if(favourites.path.length <= 1){ return } // prevent them going back to far - button should become disabled but this is just to make sure
      favourites.path.pop()
      display()
    }

    function showAddFolder(){
      favourites.addFolderView = true
    }

    function hideAddFolder(){
      favourites.addFolderView = false
      favourites.addFolderName = ""
    }

    function addFolder(){
      return favouritesSvc.add(null, "Heading", favourites.addFolderName, favourites.path[favourites.path.length-1].id)
      .then(function(res){
        hideAddFolder()
        load()
      })
    }
    
    function remove(item){
      return favouritesSvc.remove(item, load).then(function(res){
        load()
      })
    }

    function search(){
      favourites.searchView = true
      hideAddFolder()
      favourites.latestSearch = favourites.searchValue
      favourites.display = favouritesSvc.search(favourites.selectedConsultant, favourites.searchValue)
      favourites.isLoading = false
    }

    function closeSearch(){
      favourites.searchView = false
      favourites.latestSearch = ""
      favourites.searchValue = ""
      display()
    }

    function load(){
      favourites.isLoading = true
      favourites.display = []
      favourites.consultantSelf = (favourites.selectedConsultant===consultantSelf ? true : false)
      favouritesSvc.get(favourites.selectedConsultant).then(function(res){
        if(favourites.searchView){ search() }else{ display() }
      })
    }
    
    function consultantSelected(){
      favourites.path = [{id:"", name:"Home"}]
      load()
    }

  }
})()
